import type { YearGroupEnrollmentSelect } from '@tyro/groups';
import { type ReactNode, createContext, useContext } from 'react';
import type { ReturnTypeOfUseBlockList } from '../api/blocks';
import type { ListManagerGroup } from '../components/common/list-manager/state/types';

export type ClassListSettingsContextValue = {
  showGender: boolean;
  removeContainerMargin?: boolean;
  setSelectedBlock?: (
    data: NonNullable<ReturnTypeOfUseBlockList>[number] | null,
  ) => void;
  setSelectedYearGroup?: (data: YearGroupEnrollmentSelect | null) => void;
  selectedYearGroup?: YearGroupEnrollmentSelect | null;
  selectedBlock?: NonNullable<ReturnTypeOfUseBlockList>[number] | null;
  setCurrentGroupList?: (data: ListManagerGroup[]) => void;
};

const ClassListSettingsContext = createContext<
  ClassListSettingsContextValue | undefined
>(undefined);

export function ClassListSettingsProvider({
  children,
  ...value
}: ClassListSettingsContextValue & { children: ReactNode }) {
  return (
    <ClassListSettingsContext.Provider value={value}>
      {children}
    </ClassListSettingsContext.Provider>
  );
}

export function useClassListSettings() {
  const context = useContext(ClassListSettingsContext);
  if (context === undefined) {
    throw new Error(
      'useClassListSettings must be used within a ClassListSettingsContext',
    );
  }
  return context;
}
